import {Component} from "react";
import Cookies from "js-cookie";
import axiosVisitor from "../../../axios/axios_visitortag";
import * as common from "../../../const/Common/CommonFunc";
import {Col, Row} from "reactstrap";
import {Card} from "semantic-ui-react";
import PlaceHolder from "../../../components/PlaceHolder/PlaceHolder";
import React from "react";
import apiConfig from "../../../axios/axios_api_services";

let date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 8/11/19
 * Time: 12:12 AM
 */
class App extends Component {
  state = {
    spin:true,
    dashboards: []
  };

  getAllDashboards = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosVisitor.get(apiConfig.SUPER_DASHBOARD, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            dashboards: response.data.dashboardCards,
            spin: false
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDashboards();
        }
      });
  };

  componentDidMount(){
    this.getAllDashboards();
  }

  render() {
    const {dashboards} = this.state;
    return (
      <Row>
        {
          dashboards.length !== 0 ?
            dashboards.map((element, index) => (
              <Col key={index}>
                <Card
                  fluid
                  color={"orange"}
                  link
                  header={element.name}
                  meta={"Number Of All "+element.name}
                  description={element.count}
                  extra={date}

                />
              </Col>
            ))
            : <PlaceHolder data={[1,2]}/>
        }
      </Row>
    );
  }
}

export default App;
